export default (slug) => (slug ? '/' + slug : '')
